<template>
  <div>
    <ContentHeader :material-nav="false" />
    <div class="content-container">
      <el-row class="non-menu-less">
        <el-col class="item-info-box" v-loading="loading">
          <!-- 提交方式 -->
          <el-col class="item-submit-way">
            <span class="item-info-title">在线填写</span>
          </el-col>
          <!-- 在线填写table -->
          <el-col>
            <el-row class="non-menu-more-form">
              <el-col :span="6">
                <div class="form-input-row">
                  <div class="form-input-label">
                    <span class="require-text">*</span>产品名称
                  </div>
                  <el-input type="text" size="small" v-model="dataForm.itemName" />
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">
                    <span class="require-text">*</span>参考图片
                  </div>
                  <div class="prints-img">
                    <el-upload
                      ref="upload"
                      :action="fileUploadTarget"
                      :before-upload="checkBeforeUpload"
                      :on-success="handleImgSuccess"
                      :on-remove="confirmImgRemove"
                      :on-exceed="handleExceed"
                      :headers="uploadHeaders"
                      :accept="'image/*'"
                      list-type="picture"
                      :file-list="imageList"
                      multiple
                    >
                      <el-button
                        class="btn-blue-plain"
                        size="mini"
                      >上传图片</el-button>
                    </el-upload>
                  </div>
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">
                    <span class="require-text">*</span>材质工艺描述
                  </div>
                  <el-input type="text" size="small" v-model="dataForm.materialDescription" />
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">
                    <span class="require-text">*</span>最低开机量
                  </div>
                  <el-input type="text" size="small" v-model="dataForm.moqProductionBatch" />
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">
                    <span class="require-text">*</span>单个地址最低起订量
                  </div>
                  <el-input type="text" size="small" v-model="dataForm.moqDeliveryAddress" />
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-input-row">
                  <div class="form-input-label">
                    <span class="require-text">*</span>需求部门
                  </div>
                  <el-input type="text" size="small" v-model="applyBu" />
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">
                    <span class="require-text">*</span>需求人
                  </div>
                  <el-input type="text" size="small" v-model="applyPerson" />
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">
                    <span class="require-text">*</span>订购总数量
                  </div>
                  <el-input type="text" size="small" v-model="dataForm.ttlQty" />
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">
                    <span class="require-text">*</span>购买理由
                  </div>
                  <el-input type="text" size="small" v-model="dataForm.reason" />
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">产品包装要求</div>
                  <el-input type="text" size="small" v-model="dataForm.packaging" />
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-input-row">
                  <div class="form-input-label">装箱要求(几个一箱)</div>
                  <el-input type="text" size="small" v-model="dataForm.packingRequirement" />
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">使用场所</div>
                  <el-select v-model="dataForm.inOutDoor" clearable size="small">
                    <el-option label="户外" value="01" />
                    <el-option label="室内" value="02" />
                    <el-option label="户外/室内" value="03" />
                  </el-select>
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">是否需要包含到点安装</div>
                  <el-select v-model="dataForm.isInstall" clearable size="small">
                    <el-option label="是" value="1" />
                    <el-option label="否" value="0" />
                  </el-select>
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">第一批期望到货数量</div>
                  <el-input type="text" size="small" v-model="dataForm.qty1stBatch" />
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">第一批期望到货日期</div>
                  <el-date-picker
                    type="date"
                    value-format="yyyy-MM-dd"
                    v-model="dataForm.eta1stBatch"
                    placeholder="选择日期"
                    :picker-options="pickerOptions"
                    size="small"
                  ></el-date-picker>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="form-input-row">
                  <div class="form-input-label">尺寸(长宽高cm)</div>
                  <el-input type="text" size="small" v-model="dataForm.dimension" />
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">毛重(g)</div>
                  <el-input type="text" size="small" v-model="dataForm.sweight" />
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">要求保修期限</div>
                  <el-input type="text" size="small" v-model="dataForm.warranty" />
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">物料号(老产品）</div>
                  <el-input type="text" size="small" v-model="dataForm.itemNo" />
                </div>
                <div class="form-input-row">
                  <div class="form-input-label">备注</div>
                  <el-input type="text" size="small" v-model="dataForm.remark" />
                </div>
              </el-col>
              <!-- <el-table-column width="100" align="center" class-name="input-table-top">
                <template>
                  <div>
                    <el-button
                      class="btn-blue-plain add-col-btn"
                      type="primary"
                      size="small"
                      plain
                      @click="handleAddForm"
                    >新增</el-button>
                  </div>
                  <div>
                    <el-button
                      class="btn-blue-plain delete-col-btn"
                      type="danger"
                      size="small"
                      plain
                      @click="handleDeleteForm(index)"
                    >删除</el-button>
                  </div>
                </template>
              </el-table-column>-->
            </el-row>
          </el-col>
        </el-col>
      </el-row>

      <el-row class="submit-btn" type="flex" justify="center">
        <el-button type="primary" class="btn-blue-plain-hover" @click="submitOrder">提交</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import baseApi from '@/api/base'
import { tokenUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'
import ContentHeader from '../../components/content-header'
import { validateNumber } from '@/utils/validate'
export default {
  components: {
    ContentHeader
  },
  data () {
    return {
      isClear: false,
      detailList: [],
      dataForm: {
        itemName: '',
        materialDescription: '',
        moqProductionBatch: null,
        moqDeliveryAddress: null,
        ttlQty: null,
        reason: '',
        dimension: '',
        sweight: '',
        packaging: '',
        packingRequirement: '',
        inOutDoor: '',
        isInstall: null,
        qty1stBatch: null,
        eta1stBatch: '',
        warranty: '',
        itemNo: '',
        remark: '',
        fileList: []
      },
      imageList: [],
      formRules: [],
      loading: false,
      applyBu: '',
      applyPerson: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 86400000
        }
      }
    }
  },
  computed: {
    ...mapState({
      fileUploadTarget: state => state.app.fileUploadTarget
    }),

    uploadHeaders () {
      return {
        Authorization: 'Bearer ' + tokenUtils.getToken(true),
        Accept: 'application/json'
      }
    }
  },
  methods: {
    handleAddForm () {},
    handleDeleteForm () {},

    // 提交前验证
    submitCheck () {
      if (!this.dataForm.itemName) {
        this.$message.error('请输入产品名称')
        return false
      }
      if (!this.dataForm.fileList.length) {
        this.$message.error('请上传产品图片')
        return false
      }
      if (!this.dataForm.materialDescription) {
        this.$message.error('请输入材质工艺描述')
        return false
      }
      if (!this.dataForm.moqProductionBatch) {
        this.$message.error('请输入最低开机量')
        return false
      } else {
        if (!validateNumber(this.dataForm.moqProductionBatch)) {
          this.$message.error('最低开机量必须为数字')
          return false
        }
      }
      if (!this.dataForm.moqDeliveryAddress) {
        this.$message.error('请输入单个地址最低起订量')
        return false
      } else {
        if (!validateNumber(this.dataForm.moqDeliveryAddress)) {
          this.$message.error('单个地址最低起订量必须为数字')
          return false
        }
      }
      if (!this.applyBu) {
        this.$message.error('请输入需求部门')
        return false
      }
      if (!this.applyPerson) {
        this.$message.error('请输入需求人')
        return false
      }
      if (!this.dataForm.ttlQty) {
        this.$message.error('请输入订购总数量')
        return false
      } else {
        if (!validateNumber(this.dataForm.ttlQty)) {
          this.$message.error('订购总数量必须为数字')
          return false
        }
      }
      if (!this.dataForm.reason) {
        this.$message.error('请输入购买理由')
        return false
      }
      if (this.dataForm.qty1stBatch) {
        if (!validateNumber(this.dataForm.qty1stBatch)) {
          this.$message.error('第一批期望到货数量必须为数字')
          return false
        }
      }
      return true
    },

    // 提交
    submitOrder () {
      if (!this.submitCheck()) {
        return false
      }
      this.loading = true
      this.detailList = []
      this.detailList.push(this.dataForm)
      let params = {
        applyBu: this.applyBu,
        applyPerson: this.applyPerson,
        detailList: this.detailList
      }
      this.$store.dispatch('createOrderMore', params).then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.$router.replace({
            path: '/material/item-order-success',
            query: {
              orderNumber: res.data.resultData.requirementId,
              isMore: true
            }
          })
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('提交失败')
      })
    },

    getImageUrl (item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    },

    // 上传前检测
    checkBeforeUpload (file) {
      if (file.type.substr(0, 5) !== 'image') {
        this.$message.error('上传的文件不是图片文件，请重新上传')
        return false
      }
    },

    // 上传图片成功
    handleImgSuccess (res) {
      if (res.resultCode === '0') {
        this.$message.success('上传图片成功')
        this.dataForm.fileList.push({
          fileId: res.resultData.fileDTO.fileId
        })
      }
    },

    // 删除图片
    confirmImgRemove (file) {
      if (file && file.response && file.response.resultData && file.response.resultData.fileDTO) {
        const fileId = file.response
          ? file.response.resultData.fileDTO.fileId
          : file.imageFileId
        baseApi.deleteFile({ fileId: fileId }).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.warning('删除图片成功')
            this.dataForm.fileList.forEach((item, index) => {
              if (item.fileId === fileId) {
                this.dataForm.fileList.splice(index, 1)
              }
            })
          }
        })
      }
    },

    handleExceed () {}
  }
}
</script>

<style lang="scss" scoped>
.non-menu-less {
  min-width: 100%;
  margin-bottom: 15px;
  .el-col {
    padding: 0 20px;
    border-radius: 8px;
    background-color: $base-white;
  }
}
.item-info-box {
  height: 100%;
  .item-submit-way {
    height: 80px;
    line-height: 80px;
    .item-info-title {
      display: inline-block;
      padding-right: 40px;
    }
    div:last-child {
      display: inline-block;
    }
    .el-button {
      margin-right: 10px;
    }
  }
  .delivery-table {
    margin-bottom: $content-large;
  }
}
.submit-btn {
  margin-top: $page-middle;
  text-align: center;
  .el-button {
    width: 180px;
  }
}
.btn-blue-plain {
  margin-top: $content-middle;
}
.non-menu-more-form {
  .el-col {
    height: 370px;
    padding: 15px;
    margin-bottom: $content-large;
    border-radius: 0px;
    border: 1px solid #eee;
    .form-input-row {
      margin-bottom: 15px;
      .form-input-label {
        margin-bottom: 4px;
      }
    }
    .el-select,
    .el-date-editor {
      width: 100%;
    }
  }
}
.require-text {
  color: red;
  padding-right: 2px;
}
</style>
